var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value) ? _c('span', {
    staticClass: "dimensions"
  }, [_c('span', {
    staticClass: "dimensions__width"
  }, [_vm._v(_vm._s(_vm.formattedWidth))]), _vm._v(" "), _c('span', {
    staticClass: "dimensions__separator"
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "dimensions__height"
  }, [_vm._v(_vm._s(_vm.formattedHeight))]), _vm._v(" "), (_vm.formattedDepth) ? _c('span', {
    staticClass: "dimensions__separator"
  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), (_vm.formattedDepth) ? _c('span', {
    staticClass: "dimensions__depth"
  }, [_vm._v("\n    " + _vm._s(_vm.formattedDepth) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dimensions__unit"
  }, [_vm._v(_vm._s(_vm.formattedUnit))])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07a97c88","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Dimensions.vue
// module id = 1840
// module chunks = 0